<template>
  <div class="fuel-funds__distribution">
    <ul class="fuel-funds__vendor-list">
      <FuelFundsVendor v-for="(vendor, index) in percentages" :vendor="vendor" :key="index"></FuelFundsVendor>
    </ul>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import FuelFundsVendor from './FuelFundsVendor.vue';

  export default {
    name: 'FuelFundsVendors',
    components: {
      FuelFundsVendor,
    },
    computed: {
      ...mapGetters('fuelFunds', ['percentages']),
    },
  };
</script>
